/*
 * Creates a copy of \param value that shares no references with the original
 * Can only be used if all items in \param value are serializable
 *
 * As hacky as this looks, this is how the official JS docs propose users
 * create deep copies of objects
 */
export const deepCopy = <T>(value: T): T => JSON.parse(JSON.stringify(value));
